var map = {
	"./afb-color.svg": 640,
	"./alb-color.svg": 641,
	"./all.svg": 642,
	"./amb-color.svg": 643,
	"./arg.svg": 644,
	"./aus.svg": 645,
	"./bank-icon.svg": 646,
	"./bankdemo-color.svg": 647,
	"./bel.svg": 648,
	"./bimb-color.svg": 649,
	"./bkr-color.svg": 650,
	"./bpay-color.svg": 651,
	"./bra.svg": 652,
	"./bsn-color.svg": 653,
	"./can.svg": 654,
	"./checked-blue.webp": 1633,
	"./checked-green.png": 655,
	"./checked-white.png": 656,
	"./cimb-color.svg": 657,
	"./cimb-icon.svg": 658,
	"./citi-color.svg": 659,
	"./cmr.svg": 660,
	"./crc.svg": 661,
	"./cro.svg": 662,
	"./den.svg": 663,
	"./ecu.svg": 664,
	"./eng.svg": 665,
	"./esp.svg": 666,
	"./fav-blue.svg": 667,
	"./fav-blue.webp": 1634,
	"./fav-gray.png": 668,
	"./fav-gray.svg": 669,
	"./fav-gray.webp": 1635,
	"./fav-icon-active.png": 670,
	"./fav-icon.png": 671,
	"./fav-red.png": 672,
	"./fra.svg": 673,
	"./game-icon.svg": 674,
	"./games-active-m.svg": 675,
	"./games-m.webp": 1636,
	"./ger.svg": 676,
	"./gha.svg": 677,
	"./gxbank-color.svg": 678,
	"./hlb-color.svg": 679,
	"./hlb-icon.svg": 680,
	"./hsbc-color.svg": 681,
	"./irn.svg": 682,
	"./jpn.svg": 683,
	"./kor.svg": 684,
	"./ksa.svg": 685,
	"./kwh-color.svg": 686,
	"./latest-icon-active.png": 687,
	"./latest-icon.png": 688,
	"./lc-active-m.svg": 689,
	"./lc-icon.svg": 690,
	"./lc-m.webp": 1637,
	"./lottery-active-m.svg": 691,
	"./lottery-icon.svg": 692,
	"./lottery-m.svg": 693,
	"./love.svg": 694,
	"./mar.svg": 695,
	"./mbb-color.svg": 696,
	"./mex.svg": 697,
	"./ned.svg": 698,
	"./ocbc-color.svg": 699,
	"./ocbc-icon.svg": 700,
	"./p2p-active-m.svg": 701,
	"./p2p-icon.svg": 702,
	"./p2p-m.svg": 703,
	"./pbb-color.svg": 704,
	"./pol.svg": 705,
	"./por.svg": 706,
	"./price-high.svg": 707,
	"./price-low.svg": 708,
	"./qat.svg": 709,
	"./rhb-color.svg": 710,
	"./rhb-icon.svg": 711,
	"./scb-color.svg": 712,
	"./sen.svg": 713,
	"./slot-active-m.svg": 714,
	"./slot-icon.svg": 715,
	"./slot-m.webp": 1638,
	"./sport-active-m.svg": 716,
	"./sport-m.webp": 1639,
	"./sports-icon.svg": 717,
	"./srb.svg": 718,
	"./star.svg": 719,
	"./sui.svg": 720,
	"./tng-color.svg": 721,
	"./trx-icon.svg": 722,
	"./trx.svg": 723,
	"./tun.svg": 724,
	"./uob-color.svg": 725,
	"./uru.svg": 726,
	"./usa.svg": 727,
	"./usdc.svg": 728,
	"./usdt.svg": 729,
	"./ustd-icon.svg": 730,
	"./wal.svg": 731,
	"./x33-logo-b.svg": 732,
	"./x33-square-icon.svg": 733
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 464;